(function () {
    'use strict';

    angular
        .module('app.user')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'user',
                config: {
                    url: '/user',
                    abstract: true,
                    template: '<ui-view/>',
                    ncyBreadcrumb: {
                        label: 'User'
                    },
                    data: {
                        permissions: {
                            only: ['SSO:SysAdmin', 'SSO:AppAdmin', 'SSO:Site:Admin', 'SSO:Create_User'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            },
            {
                state: 'user.dashboard',
                config: {
                    url: '/dashboard',
                    templateUrl: 'app/user/dashboard/user.dashboard.html',
                    controller: 'UserDashboardController',
                    controllerAs: 'vm',
                    title: 'User Dashboard',
                    settings: {
                        isVisible: true,
                        nav: 1,
                        content: '<i class="fa fa-user"></i> User Dashboard'
                    }
                }
            }
        ];
    }
})();
